// 管理画面テンプレート
import React, { memo, useState, useEffect } from 'react';
import axios from '../axios';
import { download_wait_time } from '../Const';
import { Nav } from 'react-bootstrap';
import { maintenance_type } from '../Const';

interface Props {
  active: number | null;
  children: JSX.Element[];
}

const Maintenance: React.FC<Props> = ({ active, children }) => {
  const [is_nourin, setIsNourin] = useState(false);
  const [is_processing, setIsProcessing] = useState(false);
  // ボタン表示フラグを設定する
  const setButtonDisplayFlg = async () => {
    // フラグ初期化
    setIsNourin(false);
    // 処理中フラグを有効にする。
    setIsProcessing(true);

    try {
      // 農林中央金庫ユーザーかを判定する
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_is_nourin`
      );
      setIsNourin(response.data.result);
    } catch (error) {
      console.error(error.response.data);
    } finally {
      // ローディング停止を遅らせる
      setTimeout(() => {}, download_wait_time);
      // 処理中フラグを無効にする。
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    // ボタン表示用フラグを設定する
    setButtonDisplayFlg();
  }, []);

  return (
    <div className="maintenance">
      <div className="title">メンテナンス</div>
      <div className="maintenance_container">
        <Nav variant="tabs" defaultActiveKey={active}>
          {!is_processing && !is_nourin && (
            <Nav.Item>
              <Nav.Link
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/mail_template`}
                eventKey={maintenance_type.mail_templates}
              >
                メールテンプレート管理
              </Nav.Link>
            </Nav.Item>
          )}
          {!is_processing && (
            <Nav.Item>
              <Nav.Link
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause`}
                eventKey={maintenance_type.clauses}
              >
                同意文言管理
              </Nav.Link>
            </Nav.Item>
          )}
          {!is_processing && !is_nourin && (
            <Nav.Item>
              <Nav.Link
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents`}
                eventKey={maintenance_type.displayed_documents}
              >
                掲載書類管理
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
        <div className="contents">{children}</div>
      </div>
    </div>
  );
};

export default memo(Maintenance);
